import { mensShoppingCategoryMenu } from "./mens-shopping-category-menu-outdoor";
import { womensShoppingCategoryMenu } from "./womens-shopping-category-menu-outdoor";
import { EMAIL_SIGNUP } from "../constants/links";
import {
  isBlackFridaySaleEnabled,
  getUnder50Label,
  getUnder100Label,
  getUnder200Label,
  isGiftGuideEnabled,
} from "../helpers/outdoor";

const displayProductAdvice = (data, language) => {
  if (language !== "en") {
    return "";
  }
  return `
    <li class="product-advice">
            <a data-linkid="explore:product-advice" href="/product-advice/">${data["Product Advice"]}</a>
            </li>
      `;
};

const womensGiftGuideMenu = (data, country) => `
    <ul class="explore">
        <li class="sectionhead gifts" tabindex="1">
            <a href="/c/womens/p/gifts-for-her" data-linkid="women:gifts" data-prefix="women">${data["For Her"]}</a>
        </li>
        <div class="mobilefly">
            <li class="gifts">
                <a  data-linkid="women:gifts" data-prefix="women" href="/c/womens/p/gifts-for-her">${
                  data["Gifts for Her"]
                }</a>
            </li>
            <li class="best-sellers">
                <a  data-linkid="women:best-sellers" data-prefix="women" href="/c/womens/p/best-sellers">${
                  data["Best Sellers"]
                }</a>
            </li>
            <li class="gifts-under-50">
                <a  data-linkid="women:gifts-under-50" data-prefix="women" href="/c/womens/p/gifts-under-50">${getUnder50Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="gifts-under-100">
                <a  data-linkid="women:gifts-under-100" data-prefix="women" href="/c/womens/p/gifts-under-100">${getUnder100Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="gifts-under-200">
                <a  data-linkid="women:gifts-under-200" data-prefix="women" href="/c/womens/p/gifts-under-200">${getUnder200Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="run-gifts">
                <a  data-linkid="women:run-gifts" data-prefix="women" href="/c/womens/p/athlete-picks-run">${
                  data["Run Gifts for Her"]
                }</a>
            </li>
            <li class="climb-gifts">
                <a  data-linkid="women:climb-gifts" data-prefix="women" href="/c/womens/p/athlete-picks-climb">${
                  data["Climb Gifts for Her"]
                }</a>
            </li>
            <li class="ski-snow">
                <a  data-linkid="women:ski-snow" data-prefix="women" href="/c/womens/p/athlete-picks-ski">${
                  data["Ski + Snow for Her"]
                }</a>
            </li>
            <li class="hike-gifts">
                <a  data-linkid="women:hike-gifts" data-prefix="women" href="/c/womens/p/athlete-picks-hike">${
                  data["Hike Gifts for Her"]
                }</a>
            </li>
            <li class="veilance-gifts">
                <a  data-linkid="women:veilance-gifts" data-prefix="women" href="/c/womens/p/veilance-gifts">${
                  data["Veilance Gifts for Her"]
                }</a>
            </li>
        </div>
    </ul>
`;

const mensGiftGuideMenu = (data, country) => `
    <ul class="explore">
        <li class="sectionhead gifts" tabindex="1">
            <a href="/c/mens/p/gifts-for-him" data-linkid="men:gifts" data-prefix="men">${data["For Him"]}</a>
        </li>
        <div class="mobilefly">
            <li class="gifts">
                <a  data-linkid="men:gifts" data-prefix="men" href="/c/mens/p/gifts-for-him">${
                  data["Gifts for Him"]
                }</a>
            </li>
            <li class="best-sellers">
                <a  data-linkid="men:best-sellers" data-prefix="men" href="/c/mens/p/best-sellers">${
                  data["Best Sellers"]
                }</a>
            </li>
            <li class="gifts-under-50">
                <a  data-linkid="men:gifts-under-50" data-prefix="men" href="/c/mens/p/gifts-under-50">${getUnder50Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="gifts-under-100">
                <a  data-linkid="men:gifts-under-100" data-prefix="men" href="/c/mens/p/gifts-under-100">${getUnder100Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="gifts-under-200">
                <a  data-linkid="men:gifts-under-200" data-prefix="men" href="/c/mens/p/gifts-under-200">${getUnder200Label(
                  data,
                  country
                )}</a>
            </li>
            <li class="run-gifts">
                <a  data-linkid="men:run-gifts" data-prefix="men" href="/c/mens/p/athlete-picks-run">${
                  data["Run Gifts for Him"]
                }</a>
            </li>
            <li class="climb-gifts">
                <a  data-linkid="men:climb-gifts" data-prefix="men" href="/c/mens/p/athlete-picks-climb">${
                  data["Climb Gifts for Her"]
                }</a>
            </li>
            <li class="ski-snow">
                <a  data-linkid="women:ski-snow" data-prefix="men" href="/c/mens/p/athlete-picks-ski">${
                  data["Ski + Snow for Him"]
                }</a>
            </li>
            <li class="hike-gifts">
                <a  data-linkid="women:hike-gifts" data-prefix="men" href="/c/mens/p/athlete-picks-hike">${
                  data["Hike Gifts for Him"]
                }</a>
            </li>
            <li class="veilance-gifts">
                <a  data-linkid="women:veilance-gifts" data-prefix="men" href="/c/mens/p/veilance-gifts">${
                  data["Veilance Gifts for Him"]
                }</a>
            </li>
        </div>
    </ul>
`;

export const headerOutdoorMenus = (data, language, country) => `
<nav>
    <ul>
        <li>
            <span id="men" class="head">
                <a href="/c/mens" data-linkid="men" data-prefix="men">${data.Mens}</a>
            </span>
            <div class="sub-menu">
                <div class="container">
                    ${mensShoppingCategoryMenu(data, country)}
                    <div class="feature">
                        <a class="content" data-linkid="mens:exclusives" href="/c/mens/exclusives">
                            <h2 data-prefix="men">${data.Exclusives}</h2>
                        </a>
                    </div>
                </div>
            </div>
        </li>
        <li>
            <span id="women" class="head">
                <a href="/c/womens" data-linkid="women" data-prefix="women">${data.Womens}</a>
            </span>
            <div class="sub-menu">
                <div class="container">
                    ${womensShoppingCategoryMenu(data, country)}
                    <div class="feature">
                        <a class="content" data-linkid="womens:exclusives" href="/c/womens/exclusives">
                            <h2 data-prefix="women">${data.Exclusives}</h2>
                        </a>
                    </div>
                </div>
            </div>
        </li>
        <li>
            <a class="head explore" id="explore" href="/explore"  data-linkid="">${data["$^explore^$"]}</a>
            <div class="sub-menu">
                <div class="container">
                    <ul class="explore">
                        <li class="sectionhead shop-more" tabindex="1">
                            <span>${data["$^explore^$"]}</span>
                        </li>
                        <div class="mobilefly">
                            <li class="no-wasted-days">
                                <a data-linkid="explore:no-wasted-days" href="/explore/no-wasted-days">
                                   No Wasted Days™ 
                                </a>
                            </li>
                            <li class="whoweare">
                                <a  data-linkid="explore:who-we-are" href="/explore/whoweare">${
                                  data["$^nav-whoweare^$"]
                                }</a>
                            </li>
                            <li class="blog">
                                <a data-linkid="explore:blog" href="//blog.arcteryx.com">
                                  Blog
                                </a>
                            </li>
                            <li class="films CA-only US-only" style='display:none'>
                                <a data-linkid="explore:films" href="/explore/films">Films</a>
                            </li>
                            <li class="community-events">
                            <a data-linkid="explore:community-events" href="http://community-events.arcteryx.com">${
                              data["$^community-events^$"]
                            }</a>                            </li>
                            <li class="academy">
                                <a data-linkid="explore:academy" href="//arcteryxacademy.com">Academies</a>
                            </li>
                            <li class="athletes">
                                <a data-linkid="explore:athletes" href="/athletes">${data["Athletes & Ambassadors"]}</a>
                            </li>
                            <li class="rebird JP-block CN-block AU-block NZ-block">
                                <a data-linkid="explore:rebird" href="/explore/rebird/">ReBird™</a>
                            </li>
                            <li class="sustainability">
                                <a data-linkid="explore:sustainability" href="/explore/sustainability">${
                                  data["$^nav-sustainability^$"]
                                }</a>
                            </li>
                            <li class="arc-naming-scheme">
                            <a data-linkid="explore:arc-naming-scheme" href="/help/arc-naming">${
                              data["$^arc-naming-scheme^$"]
                            }</a>
                            </li>
                 
                            <li class="obsessive-design">
                            <a data-linkid="explore:obsessive-design" href="/explore/obsessive-design">${
                              data["Obsessive Design"]
                            }</a>
                            </li>

                            <li class="epe-fabric-sustainability">
                            <a data-linkid="explore:epe-fabric-sustainability" href="/shop/epe-fabric">${
                              data["ePE & Fabric Sustainability"]
                            }</a>
                            </li>

                            ${displayProductAdvice(data, language)}

                        </div>
                    </ul>
                    <div class="feature">
                        <a data-linkid="explore" class="content" href="/explore">
                            <h2>${data["$^explore^$"]}</h2>
                        </a>
                    </div>
                    <div class="contact">
                        <p>${data["$^SignUpTitle^$"]}</p>
                        <p class="JP-block">${data["$^SignUpBodyCopy2^$"]}</p>
                        <div>
                            <a data-linkid="explore" href="${EMAIL_SIGNUP}" tabindex="0" class="email__signup standard__cta-button" style="cursor: pointer">
                              ${data["$^SignUpCta2^$"]}
                            </a>
                        </div>
                        <p class="heading">${data["$^footer-followUs-header^$"]}</p>
                        <ul class="social">
                            <li>
                                <a data-linkid="explore:facebook" href="//facebook.com/arcteryx" class="social-na facebook" target="_blank" rel="noopener" title="Facebook">
                                    <span>Facebook</span>
                                </a>
                            </li>
                            <li>
                                <a data-linkid="explore:instagram" href="//instagram.com/arcteryx" class="social-na instagram" target="_blank" rel="noopener" title="Instagram">
                                    <span>Instagram</span>
                                </a>
                            </li>
                            <li>
                                <a data-linkid="explore:twitter" href="//twitter.com/arcteryx" class="social-na twitter" target="_blank" rel="noopener" title="Twitter">
                                    <span>Twitter</span>
                                </a>
                            </li>
                            <li>
                                <a data-linkid="explore:pinterest" href="//www.pinterest.com/arcteryx" class="social-na pinterest"
                                    target="_blank" rel="noopener" title="Pinterest">
                                    <span>Pinterest</span>
                                </a>
                            </li>
                            <li>
                                <a data-linkid="explore:youtube" href="//www.youtube.com/arcteryxequipmentinc" class="social-na youtube"
                                    target="_blank" rel="noopener" title="Youtube">
                                    <span>Youtube</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </li>
        ${
          isGiftGuideEnabled() && !isBlackFridaySaleEnabled(country)
            ? `<li>
            <a class="head gift_guide" id="gift_guide" href="/shop/giftguide/"  data-linkid="gift-guide">${
              data["$^gift-guide^$"]
            }</a>
            <div class="sub-menu">
                <div class="container gift_guide">
                    <div>
                        ${womensGiftGuideMenu(data, country)}
                        ${mensGiftGuideMenu(data, country)}
                    </div>
                    <div class="feature">
                        <a class="content" data-linkid="">
                            <h2 data-prefix="gift_guide">${data["$^gift-guide^$"]}</h2>
                        </a>
                    </div>
                </div>
            </div>
        </li>`
            : ""
        }
        ${
          isBlackFridaySaleEnabled(country)
            ? `<li>
            <a class="head explore ${
              ["fr", "de", "es"].includes(language) ? "hide_sale" : ""
            }" id="sale" data-linkid="sale">${data.Sale}</a>
            <div class="sub-menu">
                <div class="container sale">
                    <ul class="explore">
                        <div class="mobilefly">
                            <li class="f23_blackfridaysale">
                                <a  data-linkid="sale:black-friday-sale-mens" data-prefix="men" href="/c/mens/p/black-friday-sale">${
                                  data["Men's Black Friday Sale"]
                                }</a>
                            </li>
                            <li class="f23_blackfridaysale">
                                <a  data-linkid="sale:black-friday-sale-womens" data-prefix="women" href="/c/womens/p/black-friday-sale">${
                                  data["Women's Black Friday Sale"]
                                }</a>
                            </li>
                        </div>
                    </ul>
                    <div class="feature">
                        <a class="content" data-linkid="">
                            <h2 data-prefix="sale">${data["Black Friday Sale"]}</h2>
                        </a>
                    </div>
                </div>
            </div>
        </li>`
            : ""
        }
    </ul>
</nav>
`;
